<p-toast></p-toast>
<div class="card p-4 surface-card border-round-md shadow-2">
    <h2 class="mb-3">Sellouts List</h2>
    <p-toolbar styleClass="mb-4">
        <div class="p-toolbar-group-start"></div>
        <div class="p-toolbar-group-end">
            <p-button label="Export to Excel" icon="pi pi-file-excel" styleClass="p-button-help"
                (click)="exportExcel()" [loading]="isExporting"></p-button>
        </div>
    </p-toolbar>

    <div class="card p-4 surface-card border-round-md shadow-2 mb-4">
        <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
            <div class="grid formgrid p-fluid">
                <div class="field col-12 md:col-6 lg:col-3">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText type="number" formControlName="id" id="id" class="w-full">
                            <label for="id">Sellout ID</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-file"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText type="number" formControlName="settlementId" id="settlementId" class="w-full">
                            <label for="settlementId">Settlement ID</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <app-entity-dropdown-picker
                    formControlName="customers"
                    [adapter]="customerPickerAdapter"
                    inputId="customer"
                    label="Customer"
                    placeholder="Select a customer"
                    filterPlaceholder="Filter customers"
                    addonIconClass="pi pi-users"
                    columnClass="col-12 md:col-6 lg:col-6"
                ></app-entity-dropdown-picker>
                <div class="field col-12 md:col-6 lg:col-3">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-check-square"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-dropdown [options]="statusOptions" formControlName="status" styleClass="w-full"
                                [showClear]="true" inputId="status"></p-dropdown>
                            <label for="status">Status</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText formControlName="batchNumber" id="batchNumber" class="w-full">
                            <label for="batchNumber">Batch #</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-globe"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText formControlName="channel" id="channel" class="w-full">
                            <label for="channel">Channel</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-map-marker"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <input pInputText formControlName="city" id="city" class="w-full">
                            <label for="city">City</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="startDateFrom" dateFormat="yy-mm-dd" inputId="startDateFrom"
                                [showIcon]="true" [style]="{'width': '100%'}" class="w-full"></p-calendar>
                            <label for="startDateFrom">Start Date From</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
                        <p-iftalabel>
                            <p-calendar formControlName="endDateTo" dateFormat="yy-mm-dd" inputId="endDateTo"
                                [showIcon]="true" [style]="{'width': '100%'}" class="w-full"></p-calendar>
                            <label for="endDateTo">End Date To</label>
                        </p-iftalabel>
                    </p-inputgroup>
                </div>
            </div>
            <div class="flex justify-content-end gap-2 mt-4">
                <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-secondary"
                    (click)="onReset()"></p-button>
                <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
            </div>
        </form>
    </div>

    <p-table #dt [value]="sellouts" [loading]="isLoading" dataKey="selloutId" [paginator]="true" [rows]="25"
        [totalRecords]="totalRecords" [rowsPerPageOptions]="[25, 50, 100, 200]" responsiveLayout="scroll"
        [lazy]="true" (onLazyLoad)="loadSellouts($event)" sortField="selloutId" [sortOrder]="-1">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 8rem">Actions</th>
                <th pSortableColumn="selloutId">ID <p-sortIcon field="selloutId"></p-sortIcon></th>
                <th pSortableColumn="settlementId">Settlement ID <p-sortIcon field="settlementId"></p-sortIcon></th>
                <th pSortableColumn="customer.customerNumber">Customer <p-sortIcon field="customer.customerNumber"></p-sortIcon></th>
                <th pSortableColumn="business.businessName">Claim Brand <p-sortIcon field="business.businessName"></p-sortIcon></th>
                <th pSortableColumn="channel">Channel <p-sortIcon field="channel"></p-sortIcon></th>
                <th pSortableColumn="selloutStartDate">Start Date <p-sortIcon field="selloutStartDate"></p-sortIcon></th>
                <th pSortableColumn="selloutEndDate">End Date <p-sortIcon field="selloutEndDate"></p-sortIcon></th>
                <th pSortableColumn="batchNumber">Batch <p-sortIcon field="batchNumber"></p-sortIcon></th>
                <th pSortableColumn="createdBy">Uploaded By <p-sortIcon field="createdBy"></p-sortIcon></th>
                <th pSortableColumn="overrideBy">Validated By <p-sortIcon field="overrideBy"></p-sortIcon></th>
                <th pSortableColumn="validationStatus">Validation Status <p-sortIcon field="validationStatus"></p-sortIcon></th>
                <th pSortableColumn="workflowStatus.statusName">Workflow Status <p-sortIcon field="workflowStatus.statusName"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-sellout>
            <tr>
                <td>
                    <p-button icon="pi pi-eye" severity="info" [rounded]="true" [text]="true"
                        (onClick)="viewSellout(sellout.selloutId)"></p-button>
                </td>
                <td>{{ sellout.selloutId }}</td>
                <td>{{ sellout.settlementId || '-' }}</td>
                <td>{{ sellout.customer?.customerNumber }} - {{ sellout.customer?.customerName }}</td>
                <td>{{ sellout.business?.businessName || '-' }}</td>
                <td>{{ sellout.channel }}</td>
                <td>{{ sellout.selloutStartDate | date }}</td>
                <td>{{ sellout.selloutEndDate | date }}</td>
                <td>{{ sellout.batchNumber || '-' }}</td>
                <td>{{ sellout.createdBy || '-' }}</td>
                <td>{{ sellout.overrideBy || sellout.createdBy || '-' }}</td>
                <td>
                    <p-tag [value]="sellout.validationStatus || 'N/A'"
                        [severity]="getValidationStatusSeverity(sellout.validationStatus)"></p-tag>
                </td>
                <td>
                    <p-tag [value]="sellout.workflowStatus?.statusName || 'N/A'"
                        [severity]="getStatusSeverity(sellout)"></p-tag>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
